import { render, staticRenderFns } from "./ClaimStatusBadge.vue?vue&type=template&id=5c7433aa&scoped=true&lang=pug&"
import script from "./ClaimStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ClaimStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ClaimStatusBadge.vue?vue&type=style&index=0&id=5c7433aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7433aa",
  null
  
)

export default component.exports